import { useMemo } from "react";
import { object, string } from "yup";
import { testTelephone } from "src/commun/utils/ValidationsUtils";


export type VerificationTelephone = {
  mobileNumber: string;
};

const useValidationSchemaTelephone = () => {
  return useMemo(() => {
    const champInvalideMessage = "form.error.invalid";

    // Schema représentant l'ensemble des champs du formulaire
    // inclu la validation de ces champs si nécessaire
    const validationSchema = object<VerificationTelephone>().shape({
      mobileNumber: string().test("telephone-format-fr-ch", champInvalideMessage, (value) => testTelephone(value)),
    });
    return validationSchema;
  }, []);
};

export default useValidationSchemaTelephone;
